export function getTeamLogoUrl(team = {}) {
  const brandLogoUrl = String(team?.brand?.logoUrl || '').trim();
  if (brandLogoUrl) return brandLogoUrl;
  return String(team?.logoUrl || '').trim();
}
